<script lang="ts">
	import { TermsGenerator } from '#lib/features/terms/components/TermsGenerator/index.js';
	import { page } from '$app/state';
	import type { EditionsTermsPageData } from '$routes/editions/terms/types';

	let terms = $derived(page.data.terms as EditionsTermsPageData['terms']);
	let title = $derived(page.data.title as EditionsTermsPageData['title']);
</script>

<TermsGenerator dataCy="privacy" {terms} {title} />
